import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/services/api.service';
import { UtilService } from 'src/app/services/util/util.service';
import { KonfirmasiHapusComponent } from 'src/app/shared/state/konfirmasi-hapus/konfirmasi-hapus.component';
import { UserLapanganAddComponent } from 'src/app/user-lapangan/user-lapangan-add/user-lapangan-add.component';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { DetailPpComponent } from '../detail-pp/detail-pp.component';

@Component({
  selector: 'app-list-pp',
  templateUrl: './list-pp.component.html',
  styleUrls: ['./list-pp.component.css']
})
export class ListPpComponent implements OnInit {

 
   
   page: any = 1;
 
   fractionSize;
   // ionicForm: FormGroup;
   isSubmitted = false;
   nn: any = '';
   form: any = '';
 
   user: any;
   token: any;
   hasil: any;
   load: boolean = false;
 
   leadn: any = {};
   lnores: any;
   aa: any;
 
   opsi: boolean = false;
   totalCekData: any;
   pageInfo: any = {};
   pageNation: any;
 
   viewType: any;
 
   filter: any = '';
   filterr: any = '';
 
   resAr: any;
   add: any = {};
 
   leadnHapus: any = {};
 
   kinfo: any = {};
   dataInfo: any;
 
   isIndeterminate:boolean;
   masterCheck:boolean;
   checkBoxList:any;
 
   cabang: any = '';
   tenor: any = '';
   agunan: any = '';
   plafon: any = '';
   kolektor: any = '';
 
   baseUrl: any = '';
   usertoken: any = '';
 
   constructor(
     public util: UtilService,
     public api: ApiService,
     public modalController: ModalController,
     public router: Router,
     public http: HttpClient,
     public activatedRoute:ActivatedRoute
   ) {
     this.baseUrl = environment.restURL.baseUrl;
     this.usertoken = localStorage.getItem('usertoken') || 'null';
     this.activatedRoute.queryParams.subscribe(params => {
      if (params && params.refresh) {
        this.ionViewWillEnter()
      }
    });
   }
 
   ngOnInit() {
     // this.res();
   }
 
   ionViewWillEnter() {
     this.page = 1;
     this.res();
   }
 
   assign(p: any) {
     let navigationExtras: NavigationExtras = {
       queryParams: {
         no: p.id,
         // datax: JSON.stringify(p)
       }
     };
     this.router.navigate(['./add-pp'], navigationExtras);
   }
 
   async detail(p : any) {
     const modal = await this.modalController.create({
       component: DetailPpComponent,
       cssClass: 'wd-large',
       componentProps: {
         "id": p.id
       }
     });
     modal.onDidDismiss()
     .then((data) => {
       // this.page = 1;
       // this.res();
     });
     return await modal.present();
   }
 
   
   
   handleSelection(selectedValue: string, model: any) {
     if (model == 'cabang') {
       this.cabang = selectedValue;
     } else if (model == 'tenor') {
       this.tenor = selectedValue;
     } else if (model == 'agunan') {
       this.agunan = selectedValue;
     } else if (model == 'plafon') {
       this.plafon = selectedValue;
     } else if (model == 'kolektor') {
       this.kolektor = selectedValue;
     } 
     this.res()
   }
 
   reset(){
     
     this.tenor = '';
     this.agunan = '';
     this.plafon = '';
     this.kolektor = '';
     this.cabang = null;
     this.res();
   }
   
   checkMaster() {
     setTimeout(()=>{
       this.lnores.forEach(obj => {
         obj.isChecked = this.masterCheck;
       });
     });
     
   }
 
 
   checkEvent() {
     const totalItems = this.lnores.length;
     let checked = 0;
     this.lnores.map(obj => {
       if (obj.isChecked) checked++;
     });
     if (checked > 0 && checked < totalItems) {
       //Check Satu
       this.isIndeterminate = true;
       this.masterCheck = false;
       this.aa = this.lnores.filter((value, index) => {
         return value.isChecked
       });
       this.opsi = true;
     } else if (checked == totalItems) {
       //Check Semua
       this.masterCheck = true;
       this.isIndeterminate = false;
       this.aa = this.lnores.filter((value, index) => {
         return value.isChecked
       });
       this.opsi = true;
     } else {
       //Uncheck
       this.isIndeterminate = false;
       this.masterCheck = false;
       this.aa = '';
       this.opsi = false;
     }
     console.log('aa',this.aa);
     console.log('opsi',this.opsi);
    this.totalCekData = checked;
    this.resAr = { id: this.aa.map(obj => obj.contract_id) };
     console.log('resAr',this.resAr);
   }
 
 
   res() {
     let a = {
       product_name: this.nn,
     }
     let filter = {
       branch_id: this.cabang,
       _tenor_id: this.tenor,
       agunan: this.agunan,
       submission_loan_between: this.plafon,
       collector: this.kolektor
     }
     this.form = JSON.stringify({
       q: a,
       page: this.page,
       // and: filter
       // // limit:6
     });
     this.load = true;
     this.api.post('backoffice/pp/assigned/list', this.form)
       .subscribe((data) => {
         this.leadn = data;
         if (this.leadn.error == 0) {
           this.load = false;
           
             this.lnores = this.leadn.data.rows;
             this.pageInfo = this.leadn.data;
          
         } else {
           this.load = false;
           this.util.showToast(this.leadn.message, 'success', 'bottom');
         }
       }, (error) => {
         this.load = false;
         console.log('error', error);
         this.api.errorCond(error)
       });
   }
 
   firstPage() {
     this.page = 1;
     this.res();
   }
 
   prevPage() {
     this.page = this.page -= 1;
     this.res();
   }
 
   nextPage() {
     this.page = this.page + 1;
     this.res();
   }
 
   lastPage() {
     this.page = this.pageInfo.total_pages;
     this.res();
   }
 
 
 }
 